<script setup lang="ts">
import '@/assets/scss/form.scss';
import { memberShipPlanStore } from '@/modules/setting/stores/onenetwork.store.memberShip.ts';
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import moment from 'moment';
import { useConfirm, useToast } from 'primevue';
import { computed, nextTick, ref } from 'vue';
import AccountAPI from '../constants/account.api.uri.const';
import { schemaMembership } from '../helper/validationAccountSchema';
import { Icon } from '@iconify/vue/dist/iconify.js';

const confirm = useConfirm();

interface Props {
  account: any,
  isUpdate?: boolean
}
const toast = useToast();
const props = defineProps<Props>()
const loading = ref(false)
const MembershipPlanStore = memberShipPlanStore()
const packageOptions = computed(() => {
  return MembershipPlanStore.membershipPlan.map((item) => ({
    name: item.name,
    code: item.id,
  }))
})

const initialValues = ref({
  package_id: packageOptions.value.find((item) => item.code === props.account?.membership?.id) || null,
  package_expired_at: (props.account?.membership?.id && props.account?.membership_user_plan?.expired_at) ?
  new Date(props.account?.membership_user_plan?.expired_at) : '',
});


const resolver = (yupResolver(schemaMembership));
const formRef = ref();

const updateMembership = async (data: any) => {
  loading.value = true
  try{
    const res = await APIClient.put(AccountAPI.account.update.replace(':id', data.id), data);
    if (res.data.code === 200) {
      toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thành công', life: 3000 });
      editable.value = false;
      initialValues.value = {
        package_id: packageOptions.value.find((item) => item.code === res.data.data?.membership?.id) || null,
        package_expired_at: (res.data.data?.membership?.id && res.data.data?.membership_user_plan?.expired_at) ?
        new Date(res.data.data?.membership_user_plan?.expired_at) : '',
      };
      loading.value = false
      nextTick(() => {
        formRef.value?.reset();
      })
      return;
    }
  } catch (e: any) {
    loading.value = false
    const errorMessage = e.response?.data?.errors[0]?.error || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
  }
}

const onFormSubmit = async ({values, valid}: {values: Record<string, any>, valid: boolean}) => {
  console.log(values, 'values');

  if (!valid) {
    return;
  }
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {
      const formData = {
        id: props.account?.id,
        package_expired_at: values.package_expired_at ? moment(values.package_expired_at).format('YYYY-MM-DD 23:59:59') : '',
        package_id: values.package_id?.code || props.account?.membership?.id,
        update_type: "membership",
      }
      updateMembership(formData);
    },
    reject: () => {
    }
  });
};

const editable = ref(false)

const cancelEdit = () => {
  editable.value = false
  formRef.value?.reset()
}

</script>

<template>
  <div class="flex justify-between" v-if="isUpdate">
    <div></div>
    <div class="flex gap-2">
      <AllowPerm perm="account.edit_membershop" action="hide">
        <CsButton
          type="button"
          icon="ri:edit-2-fill"
          text="Chỉnh sửa"
          :visible="!editable"
          @click="editable = true"
        />
        <CsButton
          type="button"
          icon="ri:close-circle-fill"
          text="Huỷ chỉnh sửa"
          variant="danger"
          :visible="editable"
          @click="cancelEdit"
        />
      </AllowPerm>
    </div>
  </div>
  <div class="pt-3">
    <Form
      v-slot="$form"
      ref="formRef"
      :initial-values="initialValues"
      :resolver="resolver"
      @submit="onFormSubmit"
      class="flex flex-col w-full md:max-w-[600px]"
    >
      <div class="flex flex-col flex-3">
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Gói phí:</div>
          <div class="flex-2">
            <Select
              name="package_id"
              :options="packageOptions"
              optionLabel="name"
              placeholder="Chọn gói phí"
              class="form-control"
              :disabled="!editable"
            />
            <span class="italic text-[12px] text-red-500" v-if="$form.package_id?.invalid && editable">
              {{ $form.package_id.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Ngày hết hạn gói:</div>
          <div class="flex-2">
            <DatePicker class="form-control" name="package_expired_at" :disabled="!editable" :manual-input="false" />
            <span class="italic text-[12px] text-red-500" v-if="$form.package_expired_at?.invalid && editable">
              {{ $form.package_expired_at.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3" v-if="editable">
          <div class="flex-1 text-right"></div>
          <div class="flex-2">
            <!-- <button
              type="submit"
              :class="['btn btn-cs lg', loading ? 'btn-disabled' : 'success']"
              :disabled="loading"
            >
              <div :class="[loading ? 'flex items-center gap-2' : '']">
                Lưu chỉnh sửa <Icon icon="eos-icons:three-dots-loading" width="24" height="24" v-if="loading" />
              </div>
            </button> -->
            <CsButton
              type="submit"
              :disabled="loading"
              :loading="loading"
              text="Lưu chỉnh sửa"
            />
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>
